module.exports = __webpack_public_path__ + "img/icon.8e3aa102.png";